/* eslint-disable @typescript-eslint/no-explicit-any */
import { Suspense, lazy } from 'react';
import { Route, BrowserRouter, Routes, Navigate } from 'react-router-dom';
import PageNotFound from '../components/PageNotFound';
import PageLoader from '../components/PageLoader';
import RequireAuth from '../hoc/CheckAuth';
import { useSelector } from 'react-redux';
import { getUserInfo } from '../reducers/User/actions';
// import Test from '../pages/ChartsPlayground/Test';

const Login = lazy(() => import('../pages/Login'));
const AllCalls = lazy(() => import('../pages/AllCalls'));
const AuditReview = lazy(() => import('../pages/AuditReview'));
const CallDetails = lazy(() => import('../pages/CallDetails'));
const AgentInsights = lazy(() => import('../pages/AgentInsights'));
const Overview = lazy(() => import('../pages/Overview'));
const RCA = lazy(() => import('../pages/RCA'));
const AgentLeaderboard = lazy(() => import('../pages/AgentLeaderboard'));
const AggregateAgentInsights = lazy(() => import('../pages/AggregateAgentInsights'));
const AllAgents = lazy(() => import('../pages/AllAgents'));
const AuditTemplates = lazy(() => import('../pages/AuditConfiguration/AuditTemplates'));
const AuditParameters = lazy(() => import('../pages/AuditConfiguration/AuditParameters'));
// const AuditParametersCategories = lazy(() => import('../pages/AuditConfiguration/AuditParametersCategories'));
// const Dispositions = lazy(() => import('../pages/AuditConfiguration/Dispositions'));
const CallsThatNeedAttention = lazy(() => import('../pages/CallsThatNeedAttention'));
const Account = lazy(() => import('../pages/Account'));
const PlayGround = lazy(() => import('../pages/PlayGround'));
// const Usage = lazy(() => import('../pages/Usage'));
const AuditLogs = lazy(() => import('../pages/AuditLogs'));
const Billing = lazy(() => import('../pages/Billing'));
const UnprocessedCalls = lazy(() => import('../pages/UnprocessedCalls'));
const Settings = lazy(() => import('../pages/Settings'));
// const ManageUsers = lazy(() => import('../pages/Settings/ManageUsers'));
// const ManagePermissions = lazy(() => import('../pages/Settings/ManagePermissions'));
// const OtherSettings = lazy(() => import('../pages/Settings/OtherSettings'));
const Reports = lazy(() => import('../pages/Reports'));
const AgentCoaching = lazy(() => import('../pages/AgentCoaching'));
const AllCustomers = lazy(() => import('../pages/Customers/AllCustomers'));
const CustomerParameters = lazy(() => import('../pages/Customers/CustomerParameters'));
const CustomerProfile = lazy(() => import('../pages/Customers/CustomerProfile'));
const AuditAccuracy = lazy(() => import('../pages/AuditAccuracy'));
const CustomerInsights = lazy(() => import('../pages/Customers/CustomerInsights'));
const AllEmails = lazy(() => import('../pages/AllEmails'));
const EmailsOverview = lazy(() => import('../pages/EmailOverview'));
const EmailDetails = lazy(() => import('../pages/EmailChainDetails'));
const AgentEmailDetails = lazy(() => import('../pages/AgentEmailDetails'));

export default function RootRoutes() {
  const userInfo: any = useSelector(getUserInfo);

  const addons = userInfo?.addons || {};

  const hideEmailFunctionality =
    process.env.REACT_APP_HIDE_EMAIL_INSIGHTS_FUNCTIONALITY === 'true' || !addons?.email_insights;
  const isAgent = userInfo?.role === 'Agent';
  return (
    <BrowserRouter>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<Navigate replace to={isAgent ? '/agent-all-calls' : '/call-insights'} />} />
          <Route
            path="/all-calls"
            element={
              <RequireAuth>
                <AllCalls />
              </RequireAuth>
            }
          />

          <Route
            path="/agent-all-calls"
            element={
              <RequireAuth>
                <AllCalls />
              </RequireAuth>
            }
          />

          <Route
            path="/audit-accuracy"
            element={
              <RequireAuth>
                <AuditAccuracy />
              </RequireAuth>
            }
          />

          <Route
            path="/audit-review"
            element={
              <RequireAuth>
                <AuditReview />
              </RequireAuth>
            }
          />

          <Route
            path="/dispute-review"
            element={
              <RequireAuth>
                <AuditReview />
              </RequireAuth>
            }
          />

          <Route
            path="/agent-insights/:agentId"
            element={
              <RequireAuth>
                <AgentInsights />
              </RequireAuth>
            }
          />
          <Route
            path="/agent/agent-insights/:agentId"
            element={
              <RequireAuth>
                <AgentInsights />
              </RequireAuth>
            }
          />
          <Route
            path="/agent-leaderboard"
            element={
              <RequireAuth>
                <AgentLeaderboard />
              </RequireAuth>
            }
          />
          <Route
            path="/leaderboard"
            element={
              <RequireAuth>
                <AgentLeaderboard />
              </RequireAuth>
            }
          />
          <Route
            path="/call-insights"
            element={
              <RequireAuth>
                <Overview />
              </RequireAuth>
            }
          />
          <Route
            path="/rca"
            element={
              <RequireAuth>
                <RCA />
              </RequireAuth>
            }
          />
          <Route
            path="/all-agents"
            element={
              <RequireAuth>
                <AllAgents />
              </RequireAuth>
            }
          />
          <Route
            path="/aggregate-agent-insights"
            element={
              <RequireAuth>
                <AggregateAgentInsights />
              </RequireAuth>
            }
          />
          <Route
            path="/call-details/:insightId"
            element={
              <RequireAuth>
                <CallDetails />
              </RequireAuth>
            }
          />
          <Route
            path="/audit-templates"
            element={
              <RequireAuth>
                <AuditTemplates />
              </RequireAuth>
            }
          />
          <Route
            path="/audit-parameters/:templateId"
            element={
              <RequireAuth>
                <AuditParameters />
              </RequireAuth>
            }
          />
          <Route
            path="/calls-that-need-attention"
            element={
              <RequireAuth>
                <CallsThatNeedAttention />
              </RequireAuth>
            }
          />
          {/* <Route
            path="/audit-parameter-categories"
            element={
              <RequireAuth>
                <AuditParametersCategories />
              </RequireAuth>
            }
          /> */}
          {/* <Route
            path="/dispositions"
            element={
              <RequireAuth>
                <Dispositions />
              </RequireAuth>
            }
          /> */}
          <Route
            path="/playground"
            element={
              <RequireAuth>
                <PlayGround />
              </RequireAuth>
            }
          />
          {/* <Route
            path="/usage"
            element={
              <RequireAuth>
                <Usage />
              </RequireAuth>
            }
          /> */}

          <Route
            path="/billing"
            element={
              <RequireAuth>
                <Billing />
              </RequireAuth>
            }
          />

          <Route
            path="/account"
            element={
              <RequireAuth>
                <Account />
              </RequireAuth>
            }
          />
          <Route
            path="/unprocessed-calls"
            element={
              <RequireAuth>
                <UnprocessedCalls />
              </RequireAuth>
            }
          />
          <Route
            path="/settings"
            element={
              <RequireAuth>
                <Settings />
              </RequireAuth>
            }
          />

          <Route
            path="/reports"
            element={
              <RequireAuth>
                <Reports />
              </RequireAuth>
            }
          />

          <Route
            path="/agent-coaching"
            element={
              <RequireAuth>
                <AgentCoaching />
              </RequireAuth>
            }
          />

          <Route
            path="/audit-logs"
            element={
              <RequireAuth>
                <AuditLogs />
              </RequireAuth>
            }
          />

          <Route
            path="/customer-insights"
            element={
              <RequireAuth>
                <CustomerInsights />
              </RequireAuth>
            }
          />

          <Route
            path="/all-customers"
            element={
              <RequireAuth>
                <AllCustomers />
              </RequireAuth>
            }
          />

          <Route
            path="/customer-parameters"
            element={
              <RequireAuth>
                <CustomerParameters />
              </RequireAuth>
            }
          />

          <Route
            path="/customer/:customerId"
            element={
              <RequireAuth>
                <CustomerProfile />
              </RequireAuth>
            }
          />

          <Route
            path="/all-email-chains"
            element={<RequireAuth>{!hideEmailFunctionality ? <AllEmails /> : <PageNotFound />}</RequireAuth>}
          />

          <Route
            path="/email-chain-insights"
            element={<RequireAuth>{!hideEmailFunctionality ? <EmailsOverview /> : <PageNotFound />}</RequireAuth>}
          />

          <Route
            path="/email-chain-details/:insightId"
            element={<RequireAuth>{!hideEmailFunctionality ? <EmailDetails /> : <PageNotFound />}</RequireAuth>}
          />

          <Route
            path="/agent-email-details/:insightId"
            element={<RequireAuth>{!hideEmailFunctionality ? <AgentEmailDetails /> : <PageNotFound />}</RequireAuth>}
          />

          <Route path="/login" element={<Login />} />

          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
